import * as React from "react";

type Props = {
  component: React.ElementType;
  previewContent?: React.ReactNode;
  trigger: React.ReactNode;
  fullContent: React.ReactNode;
};

type State = {
  show: boolean;
};

export default class ShowMore extends React.Component<Props, State> {
  static defaultProps = {
    component: "span",
    trigger: "See More",
  };

  state = { show: false };

  render() {
    const {
      component: Component,
      previewContent,
      trigger,
      fullContent,
    } = this.props;
    if (this.state.show) {
      return <Component>{fullContent}</Component>;
    } else {
      /* eslint-disable jsx-a11y/anchor-is-valid */
      return (
        <Component>
          {previewContent}
          <a href="#" onClick={this.handleShow}>
            {trigger}
          </a>
        </Component>
      );
    }
  }

  handleShow = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState({ show: true });
  };
}
